export default __webpack_public_path__ + "static/media/Belt of Wild Furor.18aaf427.jpg";